
<template>
  <b-jumbotron>

    
    <template slot="lead">
        Quiz Completed!
    </template>
    
    <hr class="my-4" />

    <transition 
      name="firefade"
      v-on:after-enter="fireworkEnter1">
        <div class="firework firework1" v-if="fire1">
        </div>
    </transition>

    <transition 
      name="firefade"
      v-on:after-enter="fireworkEnter2">
        <div class="firework firework2" v-if="fire2">
        </div>
    </transition>

    <transition 
      name="firefade"
      v-on:after-enter="fireworkEnter3">
        <div class="firework firework3" v-if="fire3">
        </div>
    </transition>

    <b-row no-gutters class="justify-content-md-center">
      <b-col xs="6" class="justify-content-md-center">

        <b-card 
          v-if="numCorrect > 7"
          title="Just Brilliant"
          img-src="/finish3.png"
          img-alt="Image"
          img-top
          style="max-width: 20rem; margin: auto;"
          class="mb-2"
        >
          You had {{ numCorrect }} out of {{ numTotal }} correct answers.
          <br><br>
          Go ahead and try another category.
        </b-card>

        <b-card 
          v-if="numCorrect > 4 && numCorrect < 8"
          title="Very Good"
          img-src="/finish2.png"
          img-alt="Image"
          img-top
          style="max-width: 20rem; margin: auto;"
          class="mb-2"
        >
          You had {{ numCorrect }} out of {{ numTotal }} correct answers.
          <br><br>
          See if you can do even better next time.
        </b-card>

        <b-card 
          v-if="numCorrect < 5"
          title="Try Again"
          img-src="/finish1.png"
          img-alt="Image"
          img-top
          style="max-width: 20rem; margin: auto;"
          class="mb-2"
        >
          You had {{ numCorrect }} out of {{ numTotal }} correct answers.
          <br><br>
          Maybe this is just not your strongest category?
        </b-card>

      </b-col>
    </b-row>

    <b-button
      variant="primary"
      @click="repeat()"
      class="finishButton">
        Repeat
    </b-button>

    <b-button
      variant="success"
      @click="restart()"
      class="finishButton">
        Restart
    </b-button>

  </b-jumbotron>


</template>

<script>

export default {
  props: {
    numCorrect: Number,
    numTotal: Number,
    restart: Function,
    repeat: Function,
  },
  data: function() {
    return {
      fire1: false,
      fire2: false,
      fire3: false,
    }
  },
  methods: {
    fireworkEnter1: function() {
      this.fire1 = false;
      this.fire2 = true;
    },
    fireworkEnter2: function() {
      this.fire2 = false;
      this.fire3 = true;
    },
    fireworkEnter3: function() {
      this.fire3 = false;
    }
  },
  mounted: function() {
    console.log("starting Fireworks on mounted")
    if (this.numCorrect == 10) {
      this.fire1 = true;
    }
  }
}
</script>




<style>

.finishButton {
  margin: 15px 15px 0px 15px;
  min-width: 100px;
}

.firework {
  height: 20%;
  width: 20%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  z-index: 200;
}

.firework1 {
  background-image: url("/firework1.png");
  top: 140px;
  left: 10px;
}
.firework2 {
  background-image: url("/firework2.png");
  top: 10px;
  left: 250px;
}
.firework3 {
  background-image: url("/firework3.png");
  top: 140px;
  right: 10px;
}

.firefade-enter-active {
  transition: all .2s;
}

.firefade-leave-active {
  transition: all .9s;
}

.firefade-enter {
  opacity: 0;
  transform: scale(0.1);
}

.firefade-leave-to {
  opacity: 0;
  transform: scale(1.05);
}

</style>